import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandlerService } from './error-handler.service';
import { ErrorHandler, Injector, Injectable } from "@angular/core";
// import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from './modal.service';
import { ConfirmationDialogButtons } from '../base-components/confirmation-dialog/confirmation-dialog-buttons';
import { NotificationService } from './notification-service';
// import { ToastrService } from 'ngx-toastr';

@Injectable()
export class YtErrorHandler implements ErrorHandler{
    constructor(private injector: Injector
                //private notificationsService: NotificationsService
                ){
                    this.errorService = this.injector.get(ErrorHandlerService);
                    // this.notificationsService = this.injector.get(NotificationsService);
                    // this.toastrService = this.injector.get(ToastrService);
                    this.translateService = this.injector.get(TranslateService);
                    //this.router = this.injector.get(Router);
                    this.modalService = this.injector.get(ModalService);
        
    }

    private toastrService: NotificationService | null = null;
    private errorService: ErrorHandlerService;
    // private notificationsService: NotificationsService;
    // private toastrService: ToastrService;
    private translateService: TranslateService;
    //private router: Router;
    private modalService: ModalService;

    handleError(error){
        

        let message;
        let stackTrace;
        let notificationType: string;

        if(error instanceof HttpErrorResponse){
            message = this.errorService.getServerMessage(error);
            if(message instanceof ArrayBuffer)
                message = String.fromCharCode.apply(null, new Uint8Array(message));
            stackTrace = this.errorService.getServerStack(error);
            notificationType = this.getNotificationType(error.status,message);
        }
        else if (error.rejection instanceof HttpErrorResponse) {
            // Obrada za Uncaught Promise gre�ke
            message = this.errorService.getServerMessage(error.rejection);
            if(message instanceof ArrayBuffer)
                message = String.fromCharCode.apply(null, new Uint8Array(message));
            stackTrace = this.errorService.getServerStack(error.rejection);
            notificationType = this.getNotificationType(error.rejection.status,message);
        } 
        else{
            message = this.errorService.getClientMessage(error);
            stackTrace = this.errorService.getClientStack(error);
            notificationType = 'danger';
            if (error instanceof RangeError && message.includes('Maximum call stack size exceeded')){
                message="MAXIMUMCALLSTACKSIZEEXCEEDED";
            }
        }
        this.showNotification(notificationType, message, error.status ? error.status : error.rejection.status ? error.rejection.status : "");
        console.error(error);

        //if(error.status == 401){
            //this.router.navigate(['/login']);
        //}
    }

    private getNotificationType(status: number, message: string){
        switch(status){
            case 401:
            case 409: return 'warning';
            case 400: if(message.includes('Snimanje nije uspelo! Prekinuta je veza sa bazom, molimo Vas da osve�ite stranicu.')) return 'warning'
            default: return 'danger';
        }
    }

    private showNotification(notificationType: string, message: string, errorStatus: number){
        let errorMessage = message.indexOf('<->') > -1 ? message.substring(0, message.indexOf('<->')) : message;
        let messageSuffix = message.indexOf('<->') > -1 ? message.substring(message.indexOf('<->') + 3) : '';
        this.translateService.get(['FW.ERRORS.' + errorMessage, 'FW.ERROR.SINGULAR', 'FW.WARNING.SINGULAR'])
            .subscribe(translate => {
                switch(notificationType){
                    // case 'danger': this.notificationsService.error(translate['FW.ERROR.SINGULAR'], translate['FW.ERRORS.' + errorMessage].replace('FW.ERRORS.', '') + (messageSuffix != '' ? ': ' + messageSuffix : ''));break;
                    case 'danger': 
                    {
                        if (!this.toastrService) {
                            this.toastrService = this.injector.get(NotificationService);
                        }
                        this.toastrService.error(translate['FW.ERROR.SINGULAR'], translate['FW.ERRORS.' + errorMessage].replace('FW.ERRORS.', '') + (messageSuffix != '' ? ': ' + messageSuffix : ''));break;
                    }
                    
                    case 'warning': 
                    {
                        if (!this.toastrService) {
                            this.toastrService = this.injector.get(NotificationService);
                        }
                        // this.notificationsService.alert(translate['FW.WARNING.SINGULAR'], translate['FW.ERRORS.' + errorMessage].replace('FW.ERRORS.', ''));//break;
                        this.toastrService.error(translate['FW.WARNING.SINGULAR'], translate['FW.ERRORS.' + errorMessage].replace('FW.ERRORS.', ''));//break;
                        // this.modalService.ShowConfirmationDialog("Upozorenje", translate['FW.ERRORS.' + errorMessage].replace('FW.ERRORS.', ''), 'warning', errorStatus == 401 ? ConfirmationDialogButtons.OkLogin : ConfirmationDialogButtons.Ok);
                        this.modalService.ShowConfirmationDialog(translate['FW.WARNING.SINGULAR'], translate['FW.ERRORS.' + errorMessage].replace('FW.ERRORS.', ''), 'warning', errorStatus == 401 ? ConfirmationDialogButtons.OkLoginPricelist : ConfirmationDialogButtons.Ok);
                    }
                }
            })
    }
}